<template functional>
  <div>
    <el-tag v-if="props.row.Status === 'OiT'" class="OpenInTime"
      >Abierta a tiempo</el-tag
    >
    <el-tag v-if="props.row.Status === 'OoT'" class="OpenOutOfTime"
      >Abierta retrasada</el-tag
    >
    <el-tag v-if="props.row.Status === 'CiT'" class="ClosedInTime"
      >Cerrada a tiempo</el-tag
    >
    <el-tag v-if="props.row.Status === 'CoT'" class="ClosedOutOfTime"
      >Cerrada retrasada</el-tag
    >
  </div>
</template>

<script>
export default {
  name: "StatusTasks"
};
</script>

<style lang="scss" scoped>
.OpenInTime {
  background-color: #fff9c4;
  color: #f9a825;
  border: 1px solid #f9a825;
  font-weight: 700;
}

.OpenOutOfTime {
  background-color: #fff9c4;
  color: #c62828;
  border: 1px solid #c62828;
  font-weight: 700;
}

.ClosedInTime {
  background-color: #c8e6c9;
  color: #2e7d32;
  border: 1px solid #2e7d32;
  font-weight: 700;
}

.ClosedOutOfTime {
  background-color: #c8e6c9;
  color: #c62828;
  border: 1px solid #c62828;
  font-weight: 700;
}
</style>
